module.exports = __webpack_public_path__ + "static/making-ideas-happen-17519f7ae6d743e57eb88a8bd8b02b39.jpg";